import React from 'react';
import PropTypes from 'prop-types';

const DataAnalytics = ({style, className, ...props}) => {
    const strokeColor = props?.colorCode
    const strokeWidth = props?.colorCode ? "2.5" : "2";

    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
            className={className}
        >
            <path
                d="M3 3V21H21"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 9L12 6L16 10L20 6"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                cx="9"
                cy="9"
                r="1"
                fill={strokeColor}
            />
            <circle
                cx="12"
                cy="6"
                r="1"
                fill={strokeColor}
            />
            <circle
                cx="16"
                cy="10"
                r="1"
                fill={strokeColor}
            />
            <circle
                cx="20"
                cy="6"
                r="1"
                fill={strokeColor}
            />
            <path
                d="M7 14H9V18H7V14Z"
                fill={strokeColor}
            />
            <path
                d="M11 12H13V18H11V12Z"
                fill={strokeColor}
            />
            <path
                d="M15 16H17V18H15V16Z"
                fill={strokeColor}
            />
        </svg>
    );
};

DataAnalytics.propTypes = {
    fill: PropTypes.string
};

export default DataAnalytics;
